export default __webpack_public_path__ + "static/media/electric-boiler.50f64041.svg";